import {applyMiddleware, combineReducers, createStore} from "redux";
import {default as createSagaMiddleware} from "redux-saga";
import {rootSaga} from "modules/sagas";
import * as global_reducers from "modules/reducers";
import {projectSaga} from "./sagas";
import * as reducers from "./reducers";

const sagaMiddleware = createSagaMiddleware();

export const projectRootReducer = combineReducers({
	...global_reducers,
	...reducers,
});

export const projectStore = createStore(projectRootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);
sagaMiddleware.run(projectSaga);
